import { incomeReceiptWaiverPages } from './incomeReceiptWaiverPages';

export default {
  title: 'Waived income',
  pages: incomeReceiptWaiverPages,
};
